import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { Contact, Footer } from "./components/Contact";

function App() {
  return (
    <div className="site">
      <Header />
      <main>
        <Hero />
        <About />
        <Gallery />
        <Services />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-center" theme="dark" />
    </div>
  );
}

export default App;
